export const bannoTenants = { 
    banno: "banno", 
    tinker: "tinker" 
};

export const isBannoTenant = (props, fromProps = true) => {
    if (!fromProps) {
        return Object.values(bannoTenants).includes(props);
    }
    return Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const hideEnrollmentBannoTenants = (props) => {
    if (Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName) && window.parent.banno) {
        window.parent.banno.enrollment.ishow = false;
        window.parent.banno.updateEnroll(true);
    }
}

export const showEnrollmentBannoTenants = (props) => {
    if (Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName) && window.parent.banno) {
        window.parent.banno.enrollment.ishow = true;
        window.parent.banno.updateEnroll(false);
    }
}

export const updateTokenBannoTenants = (props,token) => {
    if (Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName) && window.parent.banno) {
        window.parent.banno.updateToken(token);
    }
}